import React from "react";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import '../styles/LikeButton.css';


const LikeButton = ({
	disabled,
	increamentLikes,
	likes
}) => {
	return (
		<button
			className="bg-white shadow-xl border-[1px] rounded-[40px] px-4 h-10 tracking-widest text-black font-medium"
			disabled={disabled}
			onClick={increamentLikes}
		>
			<div className="likes-button-container">
				<div>
					{
						disabled ?
						<ThumbUpOutlinedIcon className="mr-2 text-[#00A62E]" />
						:
						<ThumbUpOutlinedIcon className="mr-2" />
					}
				</div>
				<div>
					{likes}
				</div>
			</div>
		</button>
	)
}

export default LikeButton